import { render, staticRenderFns } from "./SidebarBoxBidInsideTicker.vue?vue&type=template&id=f5077c26&scoped=true&"
import script from "./SidebarBoxBidInsideTicker.vue?vue&type=script&lang=js&"
export * from "./SidebarBoxBidInsideTicker.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBoxBidInsideTicker.vue?vue&type=style&index=0&id=f5077c26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5077c26",
  null
  
)

export default component.exports